import React, { useEffect } from "react";
import "./index.css";
import { Col, Container, Row } from "react-bootstrap";
import LocationsComponent from "./COMPONENTS";
import MapComponent from "../../COMPONENTS/MAP";
import AOS from "aos";
import "aos/dist/aos.css";

const texasLocationDetails = [
  // {
  //   location: "Irving, TX",
  //   clinicName: "Elite Care Clinic",
  //   clinicAddress: "1173 W John Carpenter Fwy Ste 102, Irving, Texas 75039",
  //   map: (
  //     <iframe
  //       title="Elite Care Clinic"
  //       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13400.770176019478!2d-96.98272848403049!3d32.893077162958555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c29d32e8c9aef%3A0x7d4491d897c14169!2s1173%20W%20John%20Carpenter%20Fwy%2C%20Irving%2C%20TX%2075039%2C%20USA!5e0!3m2!1sen!2sin!4v1728538922574!5m2!1sen!2sin"
  //       width="600"
  //       height="450"
  //       style={{ border: 0 }}
  //       allowFullScreen
  //       // loading="lazy"
  //       referrerPolicy="no-referrer-when-downgrade"
  //     ></iframe>
  //   ),

  //   clinicPhone: "(469) 947-6020",
  //   clinicHours: [
  //     "Mon 08:00 am – 04:00 pm",
  //     "Tue 08:00 am – 04:00 pm",
  //     "Wed 08:00 am – 04:00 pm",
  //     "Thu 08:00 am – 04:00 pm",
  //     "Fri 08:00 am – 04:00 pm",
  //     "Sat - Closed",
  //     "Sun - Closed",
  //   ],
  // },
  {
    location: "Dallas, TX",
    clinicName: "Prime Internal Medicine Associates",
    clinicAddress: "6190 Lyndon B Johnson Fwy Ste 200, Dallas, Texas 75240",
    map: (
      <iframe
        title="Prime Internal Medicine Associates"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3349.0288054796765!2d-96.80222592602362!3d32.92383717647125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c20f10d77d0e5%3A0xa8de93b98a6d58ec!2s6190%20Lyndon%20B%20Johnson%20Fwy%20%23200%2C%20Dallas%2C%20TX%2075240%2C%20USA!5e0!3m2!1sen!2sin!4v1728538882729!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        // loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    ),
    clinicPhone: "(972) 239-5445",
    clinicHours: [
      "Mon 08:00 am – 04:00 pm",
      "Tue 08:00 am – 04:00 pm",
      "Wed 08:00 am – 04:00 pm",
      "Thu 08:00 am – 04:00 pm",
      "Fri 08:00 am – 12:00 pm",
      "Sat - Closed",
      "Sun - Closed",
    ],
  },
  {
    location: "Graham, TX",
    clinicName: "Graham Medical Associates",
    clinicAddress: "1339 East St, Graham, Texas 76450",
    map: (
      <iframe
        title="Graham Medical Associates"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.6991580857452!2d-98.58640552601432!3d33.09069846789239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8653c970bd3b3dd9%3A0xf69bc35b48461332!2s1339%20East%20St%2C%20Graham%2C%20TX%2076450%2C%20USA!5e0!3m2!1sen!2sin!4v1728538850512!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        // loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    ),
    clinicPhone: "940-521-5500",
    clinicHours: [
 "Mon 08:00 am – 04:00 pm",
      "Tue 08:00 am – 04:00 pm",
      "Wed 08:00 am – 04:00 pm",
      "Thu 08:00 am – 04:00 pm",
      "Fri 08:00 am – 12:00 pm",
      "Sat - Closed",
      "Sun - Closed",
    ],
  },
  // {
  //   location: "Las Colinas, TX",
  //   clinicName: "Your Clinic",
  //   clinicAddress: "1141 Kinwest Parkway, Irving, Texas 75063",
  //   map: (
  //     <iframe
  //       title="Your Clinic"
  //       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13398.192572987004!2d-96.98115288393953!3d32.910113159131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c284adc2c59ad%3A0x2758fcbe2d7701d7!2s1141%20Kinwest%20Pkwy%2C%20Irving%2C%20TX%2075063%2C%20USA!5e0!3m2!1sen!2sin!4v1728538815486!5m2!1sen!2sin"
  //       width="600"
  //       height="450"
  //       style={{ border: 0 }}
  //       allowFullScreen
  //       // loading="lazy"
  //       referrerPolicy="no-referrer-when-downgrade"
  //     ></iframe>
  //   ),
  //   clinicPhone: "214-239-2222",
  //   clinicHours: [
  //     "Mon 09:00 am – 05:00 pm",
  //     "Tue 09:00 am – 05:00 pm",
  //     "Wed 09:00 am – 05:00 pm",
  //     "Thu 09:00 am – 05:00 pm",
  //     "Fri 09:00 am – 05:00 pm",
  //     "Sat - Closed",
  //     "Sun - Closed",
  //   ],
  // },
  // {
  //   location: "Paris, TX",
  //   clinicName: "Muthappa Family Medicine",
  //   clinicAddress: "1601 Lamar Ave, Paris, TX 75460",
  //   map: (
  //     <iframe
  //       title="Muthappa Family Medicine"
  //       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3320.826201129301!2d-95.54211572598209!3d33.66166493825597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864a5872a1b9e521%3A0xf9a10eeae1d46f8e!2s1601%20Lamar%20Ave%2C%20Paris%2C%20TX%2075460%2C%20USA!5e0!3m2!1sen!2sin!4v1728538777785!5m2!1sen!2sin"
  //       width="600"
  //       height="450"
  //       style={{ border: 0 }}
  //       allowFullScreen
  //       // loading="lazy"
  //       referrerPolicy="no-referrer-when-downgrade"
  //     ></iframe>
  //   ),
  //   clinicPhone: "903-741-1101",
  //   clinicHours: [
  //     "Mon 09:00 am – 05:00 pm",
  //     "Tue 09:00 am – 05:00 pm",
  //     "Wed 09:00 am – 05:00 pm",
  //     "Thu 09:00 am – 05:00 pm",
  //     "Fri 09:00 am – 05:00 pm",
  //     "Sat - Closed",
  //     "Sun - Closed",
  //   ],
  // },
  // {
  //   location: "Southlake, TX",
  //   clinicName: "Timmaron Family Medicine",
  //   clinicAddress: "200 Pecan Creek, Southlake, TX 76092",
  //   map: (
  //     <iframe
  //       title="Timmaron Family Medicine"
  //       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.432666912632!2d-97.14370222602273!3d32.939584475663246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864dd45e80f1dd55%3A0x145e2918b2705c27!2s200%20Pecan%20Creek%20Dr%2C%20Southlake%2C%20TX%2076092%2C%20USA!5e0!3m2!1sen!2sin!4v1728538734460!5m2!1sen!2sin"
  //       width="600"
  //       height="450"
  //       style={{ border: 0 }}
  //       allowFullScreen
  //       // loading="lazy"
  //       referrerPolicy="no-referrer-when-downgrade"
  //     ></iframe>
  //   ),
  //   clinicPhone: "817-481-4739",
  //   clinicHours: [
  //     "Mon 09:00 am – 05:00 pm",
  //     "Tue 09:00 am – 05:00 pm",
  //     "Wed 09:00 am – 05:00 pm",
  //     "Thu 09:00 am – 05:00 pm",
  //     "Fri 09:00 am – 05:00 pm",
  //     "Sat - Closed",
  //     "Sun - Closed",
  //   ],
  // },
];
const oklahomaLocationDetails = [
  {
    location: "Midwest City, OK",
    clinicName: "Midwest Medical Group",
    clinicAddress: "1616 S Kelly Ave, Edmond, OK 73013",
    map: (
      <iframe
        title="Midwest Medical Group"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.629090978378!2d-97.49777572586648!3d35.636869332412424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b21ef64baf20a3%3A0x7b7a78523755bb95!2s1616%20S%20Kelly%20Ave%2C%20Edmond%2C%20OK%2073013%2C%20USA!5e0!3m2!1sen!2sin!4v1728538696564!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        // loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    ),
    clinicPhone: "405-739-6840",
    clinicHours: [
      "Mon 08:00 am – 04:00 pm",
      "Tue 08:00 am – 04:00 pm",
      "Wed 08:00 am – 04:00 pm",
      "Thu 08:00 am – 04:00 pm",
      "Fri 08:00 am – 12:00 pm",
      "Sat - Closed",
      "Sun - Closed",
    ],
    additionalInfo:
      "KUR Diagnostics appointments are available weekdays between 8 am - 4 pm.",
  },
  // {
  //   location: "Edmond, OK",
  //   clinicName: "Modern Endocrine",
  //   clinicAddress: "740 Signal Ridge Dr, Edmond, OK 73013",
  //   map: (
  //     <iframe
  //       title="Modern Endocrine"
  //       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.622716974801!2d-97.49752882586651!3d35.63702643240374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b21ef7b54b1677%3A0xd5903004f80a54a2!2s740%20Signal%20Ridge%20Dr%2C%20Edmond%2C%20OK%2073013%2C%20USA!5e0!3m2!1sen!2sin!4v1728538658859!5m2!1sen!2sin"
  //       width="600"
  //       height="450"
  //       style={{ border: 0 }}
  //       allowFullScreen
  //       // loading="lazy"
  //       referrerPolicy="no-referrer-when-downgrade"
  //     ></iframe>
  //   ),
  //   clinicPhone: "405-286-1571",
  //   clinicHours: [
  //     "Mon 08:00 am – 04:30 pm",
  //     "Tue 07:00 am – 04:30 pm",
  //     "Wed 08:00 am – 04:30 pm",
  //     "Thu 07:00 am – 04:30 pm",
  //     "Fri 08:00 am – 03:00 pm",
  //     "Sat - Closed",
  //     "Sun - Closed",
  //   ],
  // },
  // {
  //   location: "Edmond, OK",
  //   clinicName: "Faith Family Healthcare",
  //   clinicAddress: "7301 N Comanche Ave, Warr Acres, OK 73132",
  //   map: (
  //     <iframe
  //       title="Edmond, OK"
  //       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.2535676565376!2d-97.61914742587186!3d35.54743933731472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b204d4268c0625%3A0x6a1979430d0cbd8e!2s7301%20Comanche%20Ave%2C%20Warr%20Acres%2C%20OK%2073132%2C%20USA!5e0!3m2!1sen!2sin!4v1728538608378!5m2!1sen!2sin"
  //       width="600"
  //       height="450"
  //       style={{ border: 0 }}
  //       allowFullScreen
  //       // loading="lazy"
  //       referrerPolicy="no-referrer-when-downgrade"
  //     ></iframe>
  //   ),
  //   clinicPhone: "405-739-6840",
  //   clinicHours: [
  //     "Mon 07:30 am – 03:00 pm",
  //     "Tue 08:00 am – 03:00 pm",
  //     "Wed 07:30 am – 03:00 pm",
  //     "Thu 07:30 am – 03:00 pm",
  //     "Fri 07:30 am – 02:00 pm",
  //     "Sat - Closed",
  //     "Sun - Closed",
  //   ],
  // },
  {
    location: "Warr Acres, OK",
    clinicName: "Northwest Family Medicine",
    clinicAddress: "9800 Broadway Exd, Suite 200, OK 73114",
    map: (
      <iframe
        title="Warr Acres, OK"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12981.353837572526!2d-97.53060226916296!3d35.57003704806169!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b219685b6948d1%3A0x7f19ef394a651e65!2s9800%20Broadway%20Ext%20Suite%20200%2C%20Oklahoma%20City%2C%20OK%2073114%2C%20USA!5e0!3m2!1sen!2sin!4v1728538540839!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        // loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    ),
    clinicPhone: "405-728-2100",
    clinicHours: [
      "Mon 08:00 am – 04:00 pm",
      "Tue 08:00 am – 04:00 pm",
      "Wed 08:00 am – 04:00 pm",
      "Thu 08:00 am – 04:00 pm",
      "Fri 08:00 am – 12:00 pm",
      "Sat - Closed",
      "Sun - Closed",
    ],
  },
  {
    location: "Oklahoma City, OK",
    clinicName: "Optimal Health Associates",
    clinicAddress: "9800 Broadway Exd, Suite 200, Oklahoma City, OK 73114",
    map: (
      <iframe
        title="Oklahoma City, OK"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3245.341817887823!2d-97.51493932587053!3d35.569954136081456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b21ef5a5ba3f33%3A0xc7432606e8f37294!2sOptimal%20Health%20Associates!5e0!3m2!1sen!2sin!4v1728538390954!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        // loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    ),
    clinicPhone: "405-715-4496",
    clinicHours: [
      "Mon 08:00 am – 04:00 pm",
      "Tue 08:00 am – 04:00 pm",
      "Wed 08:00 am – 04:00 pm",
      "Thu 08:00 am – 04:00 pm",
      "Fri 08:00 am – 12:00 pm",
      "Sat - Closed",
      "Sun - Closed",
    ],
  },
  // {
  //   location: "Phoenix, AZ",
  //   clinicName: "Coming Soon",
  //   clinicAddress: "",
  //   clinicPhone: "",
  //   clinicHours: [],
  //   map: null,
  // },
];
const LocationsPage = ({ state }) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  const locationDetails = [
    ...texasLocationDetails,
    ...oklahomaLocationDetails,
  ];

  return (
    <div className="locations_section">
      <Container>
        {locationDetails.map((location, index) => (
          <Row
            key={index}
            className="location"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <Col xs={12} md={6}>
              <LocationsComponent {...location} />
            </Col>
            <Col xs={12} md={6}>
              <div className="map-placeholder" style={{ height: "400px" }}>
                <MapComponent map={location.map} />
              </div>
            </Col>
          </Row>
        ))}
      </Container>
      <div className="coming-soon-wrapper">
        <h2 className="locationTitle2">Phoenix, AZ</h2>
        <p className="coming-soon-text">Coming Soon</p>
      </div>
    </div>
  );
};

export default LocationsPage;
